import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Lock, CheckCircle } from "lucide-react";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password !== confirm) {
      setErr("Password tidak cocok");
      return;
    }
    if (password.length < 6) {
      setErr("Password minimal 6 karakter");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
    } catch (ex) {
      setErr(typeof ex?.response?.data?.detail === "string" ? ex.response.data.detail : "Reset gagal. Coba minta link baru.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-sm bg-white rounded-2xl border border-border/60 p-8 shadow-soft" data-testid="reset-password-page">
        {done ? (
          <div className="text-center space-y-4" data-testid="reset-success">
            <CheckCircle className="w-12 h-12 text-holy-green mx-auto" />
            <h1 className="font-serif text-2xl text-holy-red">Password Berhasil Diganti</h1>
            <p className="text-sm text-muted-foreground">Silakan masuk dengan password baru Anda.</p>
            <Link to="/login" data-testid="reset-goto-login" className="inline-block bg-holy-red text-ivory rounded-full px-8 py-3 font-medium">
              Masuk Sekarang
            </Link>
          </div>
        ) : (
          <form onSubmit={submit}>
            <h1 className="font-serif text-3xl text-holy-red mb-1">Buat Password Baru</h1>
            <p className="text-xs text-muted-foreground mb-6">Masukkan password baru untuk akun Anda.</p>
            {!token && (
              <div className="text-sm text-holy-red bg-holy-red/5 border border-holy-red/20 rounded-lg px-3 py-2 mb-4" data-testid="reset-no-token">
                ⚠️ Link reset tidak valid. Silakan minta link baru dari halaman Masuk.
              </div>
            )}
            <label className="block text-xs uppercase tracking-widest mb-1 text-muted-foreground">Password Baru</label>
            <div className="relative mb-4">
              <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none" />
              <input data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-cream border border-border rounded-xl pl-10 pr-4 py-3 text-sm focus:bg-white focus:border-holy-red outline-none" />
            </div>
            <label className="block text-xs uppercase tracking-widest mb-1 text-muted-foreground">Konfirmasi Password</label>
            <div className="relative mb-4">
              <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none" />
              <input data-testid="reset-confirm-input" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full bg-cream border border-border rounded-xl pl-10 pr-4 py-3 text-sm focus:bg-white focus:border-holy-red outline-none" />
            </div>
            {err && <div className="text-sm text-holy-red bg-holy-red/5 border border-holy-red/20 rounded-lg px-3 py-2 mb-3" data-testid="reset-error">⚠️ {err}</div>}
            <button type="submit" disabled={loading || !token} data-testid="reset-submit" className="w-full bg-holy-red text-ivory rounded-full py-3 font-medium hover:-translate-y-0.5 transition-all disabled:opacity-60">
              {loading ? "..." : "Simpan Password Baru"}
            </button>
            <div className="text-center mt-4">
              <Link to="/login" className="text-xs text-muted-foreground hover:text-holy-red" data-testid="reset-back-login">← Kembali ke Masuk</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
